
import { defineComponent } from 'vue';
import api from '@/api/my/hosts';
import utils from '@/utils';
import { IHostBackup } from '@/types/models';

interface IState {
  hostName: string;
  nodeName: string;
  isHongKong: boolean;
  uniqueName: string;
  nickName: string;
  backups: IHostBackup[];
}

export default defineComponent({
  name: 'Backups',
  props: {
    hostId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      hostName: '',
      nodeName: '',
      isHongKong: false,
      uniqueName: '',
      nickName: '',
      backups: [],
    } as IState;
  },
  methods: {
    apiGet() {
      api.backupsGet(this.hostId, (res) => {
        if (!res) return;
        this.hostName = res.hostName;
        this.nodeName = res.nodeName;
        this.isHongKong = res.isHongKong;
        this.uniqueName = res.uniqueName;
        this.nickName = res.nickName;
        this.backups = res.backups;
      });
    },

    apiDelete(backupId: number) {
      api.backupsDelete({
        hostId: this.hostId,
        backupId,
      }, (res) => {
        if (!res) return;
        utils.success('系统备份删除成功！');
        this.apiGet();
      });
    },

    apiRestore(backup: IHostBackup) {
      api.backupsRestore({
        hostId: this.hostId,
        backupId: backup.id,
      }, (res) => {
        if (!res) return;
        utils.success(`系统备份 ${backup.backupDate} 还原成功，SSCMS 管理后台正在重新启动，请等待几分钟后进入！`);
      });
    },

    getUrl(hostName: string, nodeName: string, isHongKong: boolean): string {
      return utils.getHostUrl(hostName, nodeName, isHongKong);
    },

    btnBackupClick() {
      api.backupsSubmit(this.hostId, (res) => {
        if (!res) return;
        utils.success('系统备份成功！');
        this.apiGet();
      });
    },

    btnRestoreClick(backup: IHostBackup) {
      utils.alertDelete(
        {
          title: '还原系统备份',
          text: `此操作将还原系统备份 ${backup.backupDate}，当前网站云的数据及文件将被覆盖，备份之后新增的数据将丢失，确定吗？`,
          button: '确认还原',
        },
        () => {
          this.apiRestore(backup);
        },
      );
    },

    btnDeleteClick(backup: IHostBackup) {
      if (backup.isSystem) return;
      utils.alertDelete(
        {
          title: '删除系统备份',
          text: `此操作将删除系统备份 ${backup.backupDate}，确定吗？`,
          button: '确认删除',
        },
        () => {
          this.apiDelete(backup.id);
        },
      );
    },
  },
  watch: {
    hostId: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.apiGet();
        }
      },
      deep: false,
    },
  },
  mounted() {
    this.apiGet();
  },
});
